import React, { FC } from 'react';
import { AdPreviewProps } from '../../types';
import { FacebookAdContainer } from './FacebookAdContainer';

export const FacebookVideoAd: FC<AdPreviewProps> = ({
  agencyLogo,
  logoBgColor,
  agencyName,
  description,
  websiteUrl,
  longHeadline,
  shortHeadline,
  children
}) => {
  return (
    <FacebookAdContainer
      pageName={agencyName}
      agencyLogo={agencyLogo}
      logoBgColor={logoBgColor}
      description={description}
      website={websiteUrl}
      title={shortHeadline}
      headline={longHeadline}
    >
      {children}
    </FacebookAdContainer>
  );
};
